import { CircularProgress } from "@mui/material";

export const ButtonContentWithLoader = (isLoading, normalText) => {
    if (isLoading) return <>&nbsp;<CircularProgress color="inherit" size={20} />&nbsp;</>;
    else return normalText;
}